import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from '../../../components/LoadingScreen';

const UnifiedPrequalOffer = loadable(() => import('./UnifiedPrequalOffer'), {
  fallback: <LoadingScreen />,
});

export default UnifiedPrequalOffer;
